import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "animate-spin h-5 w-5 absolute",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["focus:outline-none outline-none text-sm transition-all duration-300 whitespace-nowrap flex justify-center items-center", _ctx.classNameArray]),
    onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMousedown && _ctx.handleMousedown(...args))),
    onMouseup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseup && _ctx.handleMouseup(...args))),
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center", { 'opacity-0': _ctx.loading }])
    }, [
      _renderSlot(_ctx.$slots, "icon"),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 34))
}